import { render, staticRenderFns } from "./ListCategory.vue?vue&type=template&id=d401a6c0&"
import script from "./ListCategory.vue?vue&type=script&lang=js&"
export * from "./ListCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports